module.exports = __webpack_public_path__ + "assets/e4bcad86a55d83b8cc3987ed64f83787.svg";